module.exports = __webpack_public_path__ + "static/7-2e1d33ddb6ac4844bfd2e25ca48caa81.jpg";